export const navItems = [
    {
      id: 1,
      title: "O nas",
      path: "/onas",
      cName: "nav-item",
    },
    {
      id: 2,
      title: "Finanse",
      path: "",
      cName: "nav-item",
    },
    {
      id: 3,
      title: "Prawo",
      path: "/prawo",
      cName: "nav-item",
    },
    {
      id: 4,
      title: "Personal media",
      path: "/personalmedia",
      cName: "nav-item",
    },
  ];
  
  export const finanseDropdown = [
    {
      id: 1,
      title: "Kredyty firmowe",
      path: "/kredytyfirmowe",
      cName: "submenu-item",
    },
    {
      id: 2,
      title: "Kredyty hipoteczne",
      path: "/kredytyhipoteczne",
      cName: "submenu-item",
    },
    {
      id: 3,
      title: "Pożyczki unijne",
      path: "/pozyczkiunijne",
      cName: "submenu-item",
    },
    {
      id: 4,
      title: "Leasingi",
      path: "/leasingi",
      cName: "submenu-item",
    },
  ];